import { render, staticRenderFns } from "./Block4.vue?vue&type=template&id=74100b13&scoped=true&"
import script from "./Block4.vue?vue&type=script&lang=js&"
export * from "./Block4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74100b13",
  null
  
)

export default component.exports